
import { ApiSupportSelector } from "../../helpers/apiSupport"
import { ContactDto } from "../models"
import { InitialState } from "../reducers/types"


export const Selector = {
    get: (state): InitialState => {
        return state.contactReducer
    },

    geDuplicateContactsByEmail: (state): ContactDto[] => {
        return state.contactReducer.duplicatedContactsByEmail || []
    },

    geDuplicateContactsByPhoneNumber:(state): ContactDto[] => {
        return state.contactReducer.duplicatedContactsByPhoneNumber
    },

    getApiStatus: (state) => {
        return ApiSupportSelector(Selector.get(state))
    }
}


// WEBPACK FOOTER //
// ./src/state/contact/selectors/selectors.ts